<template>
  <div class="h-100" style="min-height: 1px">
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeDownShort">
        <div v-if="!loading" class="d-flex flex-column h-100">
          <b-card
            body-class="py-0"
            class="border-0 mb-3"
            header-class="pb-2 border-0 bg-transparent"
          >
            <template #header>
              <div class="d-flex justify-content-between">
                <div class="title">
                  <h3 class="d-inline-block font-weight-bolder mb-0 mr-2">
                    <icon
                      class="icon-fw"
                      scale="0.75"
                      :name="
                        $store.getters['energetic/getTypeByID'](
                          current.data.typeID,
                        ).icon
                      "
                    />
                    {{
                      current.data.powerNumber ||
                      current.data.gasNumber ||
                      current.data.waterNumber ||
                      current.data.heatNumber
                    }}
                  </h3>
                </div>
                <h4 class="font-weight-normal text-muted mb-0">
                  {{ current.data.localityName }}
                </h4>
              </div>
            </template>
            <div class="d-flex justify-content-between">
              <b-nav class="nav-base">
                <b-nav-item
                  :to="{
                    name: 'reportConsumer',
                    query: { year: current.meta.reportYears[0] },
                  }"
                >
                  <b-icon class="mr-1" icon="file-earmark-text" />
                  Fakturačné dáta
                </b-nav-item>
                <b-nav-item
                  v-if="
                    current.data._type.const === 'POWER' ||
                    current.data._type.const === 'GAS'
                  "
                  :to="{ name: 'reportPerformance' }"
                >
                  <b-icon class="mr-1" icon="graph-up" />
                  Výkonové dáta
                </b-nav-item>
                <b-nav-item
                  v-if="current.data.energy_data"
                  :to="{ name: 'intervalData' }"
                >
                  <b-icon class="mr-1" icon="calendar4-week" />
                  Intervalové dáta
                </b-nav-item>
              </b-nav>
              <transition name="fadeLeftShort">
                <b-form
                  v-if="
                    $route.name === 'reportConsumer' &&
                    current.meta.reportYears.length
                  "
                  inline
                >
                  <label class="font-weight-bold mr-2">Rok:</label>
                  <b-form-select v-model="year" size="sm" :select-size="1">
                    <option
                      v-for="y in current.meta.reportYears"
                      :key="y"
                      :value="y"
                    >
                      {{ y }}
                    </option>
                  </b-form-select>
                </b-form>
              </transition>
            </div>
          </b-card>
          <transition mode="out-in" name="fadeDownShort">
            <router-view :key="$route.query.year" />
          </transition>
        </div>
      </transition>
    </b-overlay>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  watch: {
    '$route.query.year'(val) {
      if (!val && this.$route.name === 'reportConsumer') {
        this.getCurrent()
      }
    },
  },
  computed: {
    ...mapState({
      current: (state) => state.energetic.current,
      loading: (state) => state.energetic.current.loading,
    }),
    year: {
      get() {
        return this.$route.query.year
      },
      set(val) {
        this.$router
          .push({
            query: {
              year: val,
            },
          })
          .catch(() => {})
      },
    },
  },
  created() {
    this.getCurrent()
  },
  mounted() {
    this.$root.$on('reloadConsumerReportData', this.getCurrent)
  },
  beforeDestroy() {
    this.$root.$off('reloadConsumerReportData')
  },
  methods: {
    getCurrent() {
      this.$store
        .dispatch('energetic/getCurrent', {
          id: this.$route.params.energetics_id,
        })
        .then(() => {
          this.gotoFirst()
        })
    },
    gotoFirst() {
      if (this.$route.name === 'reportConsumer' && !this.$route.query.year) {
        if (this.current.meta && this.current.meta.reportYears.length > 0) {
          this.$router.push({
            query: {
              year: this.current.meta.reportYears[0],
            },
          })
        }
      }
    },
  },
}
</script>
